'use client';

import { useOrganization, useUser } from '@clerk/nextjs';
import { useTranslations } from 'next-intl';
import type React from 'react';

import { hasPaidAccess } from '../../contracts/account';
import { Link } from '../../i18n/navigation';

// A paid-only nav link to the Train surface. Renders nothing for signed-out or
// free users, so the same access policy the page/API enforce is reflected in the
// nav (UI and API never disagree about who can reach it).
export function TrainLink(): React.JSX.Element | null {
  const t = useTranslations('train.nav');
  const { user } = useUser();
  const { organization } = useOrganization();
  if (!user) {
    return null;
  }
  if (!hasPaidAccess(user.publicMetadata, organization?.publicMetadata)) {
    return null;
  }
  return (
    <Link
      href="/train"
      className="text-sm font-medium text-gray-700 transition-colors hover:text-gray-900"
    >
      {t('link')}
    </Link>
  );
}
